import { BetrokkenTrein } from "@/entities/betrokken-treinen";
import { useGetStationDisplayName } from "@/entities/station";
import { AddOrUpdateTreinEvacuatieDialog } from "@/features/betrokken-treinen/components/evacuatie-trein/trein-evacuatie-dialog.tsx";
import { ActionsDropdown, Button, DropdownMenuItem } from "@/shared/components";
import { useState } from "react";

type EvacuatieTreinProps = {
    dossierId: string;
    trein: BetrokkenTrein;
};

export function BetrokkenTreinEvacuatieTrein({ dossierId, trein }: EvacuatieTreinProps) {
    const [evacuatieTreinDialogOpen, setEvacuatieTreinDialogOpen] = useState(false);
    const stationDisplayName = useGetStationDisplayName("stationCodeSuffixed");

    if (!trein.treinEvacuatie) {
        return null;
    }

    const { vertrekTijd, toelichting, afzetStations } = trein.treinEvacuatie;

    return (
        <div className="border-default flex w-full flex-col gap-4 rounded-l border px-4 py-2">
            <div className="flex justify-between">
                <h3 className="leading-m text-l font-medium">Evacuatietrein</h3>
                <ActionsDropdown>
                    <DropdownMenuItem onClick={() => setEvacuatieTreinDialogOpen(true)}>Evacuatietrein aanpassen</DropdownMenuItem>
                </ActionsDropdown>
            </div>
            <dl className="grid gap-y-2">
                <div>
                    <dt className="leading-l text-s text-content-emphasis font-bold">Vertrektijd</dt>
                    <dd>{vertrekTijd}</dd>
                </div>
                <div>
                    <dt className="leading-l text-s text-content-emphasis font-bold">Afzetstations</dt>
                    {afzetStations.map((afzetStation) => (
                        <dd key={afzetStation}>{stationDisplayName(afzetStation)}</dd>
                    ))}
                </div>
                {toelichting && (
                    <div>
                        <dt className="leading-l text-s text-content-emphasis font-bold">Toelichting</dt>
                        <dd>{toelichting}</dd>
                    </div>
                )}
            </dl>

            <AddOrUpdateTreinEvacuatieDialog
                dossierId={dossierId}
                trein={trein}
                open={evacuatieTreinDialogOpen}
                setOpen={setEvacuatieTreinDialogOpen}
            />
        </div>
    );
}

export function BetrokkenTreinEvacuatieTreinToevoegen({ dossierId, trein }: EvacuatieTreinProps) {
    const [evacuatieTreinToevoegenDialogOpen, setEvacuatieTreinToevoegenDialogOpen] = useState(false);

    return (
        <>
            <Button
                icon="train-spr-alt"
                iconStrokeWidth="normal"
                iconSize="xs"
                variant="tertiary"
                className="text-s order-3 col-span-1"
                onClick={() => setEvacuatieTreinToevoegenDialogOpen(true)}
            >
                Evacuatietrein toevoegen
            </Button>
            <AddOrUpdateTreinEvacuatieDialog
                dossierId={dossierId}
                trein={trein}
                open={evacuatieTreinToevoegenDialogOpen}
                setOpen={setEvacuatieTreinToevoegenDialogOpen}
            />
        </>
    );
}
